import { Button, Divider, Flex, Select, Space, Typography } from 'antd';
import CopyReferrerLink from '../CopyReferrerLink/CopyReferrerLink';

interface ReferrerActionBarProps {
  selectedReferrer: string;
  handleReferrerSelect: (value: string) => void;
  scReferrersOption: { value: string; label: string }[];
  setSelectedReferrer: (value: string) => void;
  startApplication: () => void;
}

const ReferrerActionBar = ({
  selectedReferrer,
  handleReferrerSelect,
  scReferrersOption,
  setSelectedReferrer,
  startApplication,
}: ReferrerActionBarProps) => (
  <Space direction="horizontal" size={8}>
    <Divider type="vertical" plain />
    <div title="You can start/resume the application flow for any client, or share link with them">
      <Flex justify="space-between" gap={8} align="center">
        <Select
          placeholder="Copy Referrer Link"
          value={selectedReferrer}
          className="w-40"
          onChange={handleReferrerSelect}
          allowClear
          onClear={() => setSelectedReferrer('')}
          showSearch
          options={scReferrersOption}
          optionLabelProp="value"
          disabled={scReferrersOption.length <= 1}
        />
        <Button
          type="primary"
          title="Start/resume loan application by entering client's phone number"
          onClick={startApplication}
        >
          Apply loan
        </Button>
        <Typography>or</Typography>
        <CopyReferrerLink referrerCode={selectedReferrer} linkType="referrer" />
      </Flex>
    </div>
  </Space>
);

export default ReferrerActionBar;
